import { useQuery } from '@tanstack/react-query';
import { billingService } from '@/services/billing/billingService';
import { billingKeys } from './queryKeys';

export const useBillingData = (companyId: string | undefined) => {
  return useQuery({
    queryKey: billingKeys.data(companyId || ''),
    queryFn: () => billingService.getBillingData(companyId!),
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: (failureCount, error) => {
      // Don't retry on data integrity errors
      if (error.message.includes('multiple subscriptions')) {
        return false;
      }
      return failureCount < 3;
    },
  });
};
